import { Pipe, PipeTransform } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { PeopleFacadeService, Person } from '@app/src/app/people';

/**
 * Convenience pipe for getting Person from a person's hash.
 */
@Pipe({ name: 'mgPerson' })
export class MgPersonPipe implements PipeTransform {
  constructor(private people: PeopleFacadeService) {}

  transform(value: any, options?: any): Observable<Person | null> {
    if (typeof value !== 'string') {
      console.warn('mgPerson requires string type. Got', value);
      return of<Person | null>(null);
    }

    return this.people.getPeople([value]).pipe(map(result => result[0]));
  }
}
